import type { ReactNode } from 'react';
import { ApiError } from '../lib/errors';

interface Props {
  isLoading: boolean;
  error: unknown;
  children: ReactNode;
  skeleton?: ReactNode;
}
export function LoadingBoundary({ isLoading, error, children, skeleton }: Props) {
  if (isLoading) return <>{skeleton ?? <div className="skeleton">Loading…</div>}</>;
  if (error) {
    const isApi = error instanceof ApiError;
    return (
      <div className="error-card">
        <h2 className="anton">Something went wrong.</h2>
        <p>{isApi ? `${error.code}: ${error.message}` : String(error)}</p>
        {isApi && error.requestId && (
          <button onClick={() => navigator.clipboard.writeText(error.requestId!)} className="btn btn-ghost-dark btn-sm">
            Copy request ID
          </button>
        )}
      </div>
    );
  }
  return <>{children}</>;
}
